import React from 'react'
import { FormFeedback, Input } from 'reactstrap'
import api from '../../../api/api'
import ParadigmaModal from '../../../components/ParadigmaModal/ParadigmaModal'

export default class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tipo: '',
            errors: {},
        }
    }

    resetState = () => {
        this.setState({
            tipo: '',
            errors: {}
        })
    }
    setData = (data) => {
      this.setState({tipo: data.nombre})
    }
    getData = () => {
        return {tipo: this.state.tipo}
    }

    onValidation = () => {
        if(!!!this.state.tipo){
            this.setState({errors: {tipo: "Ingrese un campo válido."}})
            return false
        }
        return true
    }
    onChangeTipo = (value) => {
        this.setState(prevState => ({
            tipo: value,
            errors: {
                ...prevState.errors,
                tipo: null
            }
        }))
    }
    getModalVars = () => {
      const { action, onClose } = this.props;
      if (this.props.action=='CREATE'){
        return {
          action: action,
          postUrl: api.proyectos.cargadatos.convenios.tipos.create,
          buttonTitle: "Nuevo",
          onClose: () => this.resetState() & (onClose && onClose()),
          onPreSubmit: () => this.getData(),
          onValidation: () => this.onValidation(),
          onSubmit: this.props.onSubmit,
          disabled: false,
          successMessage: "El tipo de convenio ha sido creado con éxito.",
          title: "Nuevo tipo de convenio",
          buttonIcon: "fa fa-plus fa-lg",
          saveButton: true,
          closeButton: true,
          className: "ui-modal-dialog",
        }
    }
      else if (action == "EDIT") {
          return {
              action,
              getUrl: api.proyectos.cargadatos.convenios.tipos.detail,
              postUrl: api.proyectos.cargadatos.convenios.tipos.edit,
              id: this.props.id,
              onGotData: (data) => this.setData(data),
              onPreSubmit: () => this.getData(),
              onClose: () => this.resetState() & (onClose && onClose()),
              onSubmit: this.props.onSubmit,
              disabled: false,
              title: "Editar el tipo de convenio",
              successMessage: "El tipo ha sido editado con éxito.",
              buttonIcon: "fa fa-pencil fa-lg",
              closeButton: true,
              saveButton: true,
              buttonTitle: "Editar",
              className: "ui-modal-dialog",
          }
      }
    else if (action=="DELETE") {
        return {
          action,
          getUrl: api.proyectos.cargadatos.convenios.tipos.detail,
          postUrl: api.proyectos.cargadatos.convenios.tipos.delete,
          id: this.props.id,
          onGotData: (data) => this.setData(data),
          onClose: () => this.resetState() & (onClose && onClose()),
          onSubmit: this.props.onSubmit,
          disabled: true,
          title: "Eliminar tipo de convenio",
          successMessage: "El tipo ha sido eliminado con éxito.",
          buttonIcon: "fa fa-trash fa-lg",
          danger: true,
          closeButton: true,
          saveButton: true,
          buttonClass: "btn-danger",
          saveButtonLabel: "Eliminar",
          buttonTitle: "Eliminar",
          className: "ui-modal-dialog",
        }
    }
  }
  render(){
        const modalVars=this.getModalVars();
        const {errors, tipo} = this.state
      return (
          <ParadigmaModal {...modalVars}>
            <div className="ui-form">
                {this.props.action=="DELETE" &&
                    <div className="ui-alert ui-alert-danger">
                        Esta acción eliminará el tipo de convenio seleccionado.
                    </div>
                }
                <section className="ui-section-block">
                    <h5 className="ui-section-label">Tipo de convenio</h5>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <label>Nombre</label>
                            <Input
                                name="tipo"
                                autoFocus={!modalVars.disabled}
                                data-auto-focus={!modalVars.disabled ? "true" : null}
                                value={tipo}
                                onChange={(evt) => this.onChangeTipo(evt.target.value)}
                                disabled={modalVars.disabled}
                            />
                            <FormFeedback className={(errors.tipo != undefined ? "d-block" : "")}>{errors.tipo}</FormFeedback>
                        </div>
                    </div>
                </section>
            </div>
        </ParadigmaModal>
      )
  }
}



// WEBPACK FOOTER //
// ./src/views/Convenios/Tipos/Modal.js